import { useCallback } from 'react'
import { useTheme } from '@mui/material'
import { Area, Line, ReferenceLine } from 'recharts'
import { useTimelineStyles } from '~/crop/crop-schedule/hooks/use-timeline-styles'

export const GddBandFill = ({ eraseFill }) => {
  const theme = useTheme()
  return (
    <>
      <Area
        type="monotone"
        dataKey="avgHigh"
        baseValue="avgLow"
        stroke="none"
        fill={theme.palette.primary.light}
        fillOpacity={0.25}
        isAnimationActive={false}
        legendType="none"
        dot={false}
      />
      <Area
        type="monotone"
        dataKey="avgLow"
        stroke="none"
        fill={eraseFill}
        fillOpacity={1}
        isAnimationActive={false}
        legendType="none"
        dot={false}
      />
    </>
  )
}

export const GddLines = () => {
  const theme = useTheme()
  return (
    <>
      <Line
        type="monotone"
        dataKey="avgHigh"
        stroke={theme.palette.primary.light}
        strokeWidth={1}
        dot={false}
        isAnimationActive={false}
        legendType="none"
      />
      <Line
        type="monotone"
        dataKey="avgLow"
        stroke={theme.palette.primary.light}
        strokeWidth={1}
        dot={false}
        isAnimationActive={false}
        legendType="none"
      />
    </>
  )
}

export const GddReferenceLines = ({ currentDoy, lfd, ffd, yMax }) => {
  const { TimelineStyles } = useTimelineStyles()
  const lineSegment = useCallback((x) => ([
    { x, y: 0 },
    { x, y: yMax },
  ]), [yMax])
  return (
    <>
      <ReferenceLine
        segment={lineSegment(currentDoy)}
        stroke={TimelineStyles.now.fillColor}
        strokeWidth={TimelineStyles.now.width}
      />
      {lfd != null && (
        <ReferenceLine
          segment={lineSegment(lfd)}
          stroke={TimelineStyles.frost.color}
          strokeWidth={1}
          strokeDasharray="6 2"
        />
      )}
      {ffd != null && (
        <ReferenceLine
          segment={lineSegment(ffd)}
          stroke={TimelineStyles.frost.color}
          strokeWidth={1}
          strokeDasharray="6 2"
        />
      )}
    </>
  )
}
